import { render, staticRenderFns } from "./MemorizingWords1.vue?vue&type=template&id=5dae6412&"
import script from "./MemorizingWords1.vue?vue&type=script&lang=js&"
export * from "./MemorizingWords1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports